import React from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_INVOICE_EINVOICE_DATA', LOG_LEVELS.DEBUG);

const InvoiceEInvoiceData = ({ eInvoiceDataLines = [] }) => {
  log.debug('render(): ', { eInvoiceDataLines });

  if (!eInvoiceDataLines || eInvoiceDataLines.length === 0) {
    return <div></div>;
  }

  return (
    <div>
      <h2 className="mt30"><LanguageStringResolver string='transactionInvoice_eInvoiceData'/></h2>
      <table>
        {eInvoiceDataLines.map((item, index) => (
          <tbody key={index}>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_eInvoiceData_UniqueDocumentCode'/></p></td>
              <td><p>{item.uniqueDocumentCode || ''}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_eInvoiceData_UniqueDocumentCodeCountry'/></p></td>
              <td><p>{item.uniqueDocumentCodeCountry || ''}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_eInvoiceData_UniqueDocumentCodeType'/></p></td>
              <td><p>{item.uniqueDocumentCodeType || ''}</p></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
  );
};

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {};
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(InvoiceEInvoiceData);
